import { formatProductionRunHolderLabel } from "./productionRunHolderLabel";

export function ProductionRunHolderOverlay({
  holderKey,
  holderDisplayName,
  viewerUserId,
  viewerDisplayName,
}: {
  holderKey?: string | null;
  holderDisplayName: string | null;
  viewerUserId?: string | null;
  viewerDisplayName?: string | null;
}): JSX.Element {
  const label = formatProductionRunHolderLabel({
    holderKey,
    holderDisplayName,
    viewerUserId,
    viewerDisplayName,
  });

  return (
    <div className="absolute inset-0 z-20 flex items-center justify-center rounded-lg bg-background/90 p-6 backdrop-blur-sm">
      <div className="max-w-md space-y-3 text-center">
        <h3 className="text-lg font-semibold">Production in use</h3>
        <p className="text-sm text-muted-foreground">
          {label
            ? `${label} is running Cal+Test on this bench.`
            : "Another operator is running Cal+Test on this bench."}
        </p>
        <p className="text-sm text-muted-foreground">
          {label === "NiceGUI Production"
            ? "Finish or use Start over in the SDTestApp NiceGUI Production tab, then reload Cal+Test."
            : "Wait until they finish and clock out, or ask them to release the workflow from the final step."}
        </p>
      </div>
    </div>
  );
}
